import { useContext } from "react";
import { NotifierContext } from "App/Notifier";
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { useHistory } from "react-router-dom";
import { useTypedDispatch } from "App/Store";
import AddStoreForm from "components/AddStoreForm";
import { addStore } from "core/services/Store";

export default function AddStore() {
  const dispatch = useTypedDispatch();
  const { showNotification } = useContext(NotifierContext);
  const history = useHistory();

  function handleAddStore(storeData: any) {
    dispatch(showLoader());
    const formData = new FormData();
    Object.entries(storeData).forEach(([key, value]: any) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value) && value.every(v => v instanceof File)) {
        value.forEach((file) => {
          formData.append(key, file); 
        });      
      } else if (typeof value === "string") {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    });
  
    addStore(formData).then((res) => {
      if (res.status) {
        showNotification({
          message: "Added Successfully",
          title: "Success",
          type: "success",
        });
        history.replace("/store");
      } else {
        showNotification({
          message: res.message || "This store cannot be created",
          title: "Error",
          type: "error",
        });
      }
      dispatch(hideLoader());
    });
  }

  return <AddStoreForm onAddStore={handleAddStore} isEditMode={false} />;
}
